import React from 'react';
import { Button } from '@gravity-ui/uikit';
import { cn } from '../../classname';
import { i18n } from '../../i18n/forms';
import './FormFooter.css';
const b = cn('form-footer');
export const FormFooter = ({ className, onCancel, onSubmit, children, }) => {
    return (React.createElement("div", { className: b(null, [className]) },
        onCancel && (React.createElement(Button, { size: "s", view: "flat-secondary", onClick: onCancel }, i18n('common_action_cancel'))),
        onSubmit && (React.createElement(Button, { size: "s", view: "action", onClick: onSubmit }, i18n('common_action_submit'))),
        children));
};
